// Private field helpers (duplicated from recently-viewed.js)
var __privateAdd = (obj, privateCollection, value) => {
  if (privateCollection.has(obj)) {
    throw new TypeError('Cannot add the same private member more than once')
  }
  if (privateCollection instanceof WeakSet) {
    privateCollection.add(obj)
  } else {
    privateCollection.set(obj, value)
  }
}

var __privateGet = (obj, privateCollection, getter) => {
  if (!privateCollection.has(obj)) {
    throw new TypeError('Attempted to get private field on non-instance')
  }
  if (getter !== undefined) {
    return getter
  }
  return privateCollection.get(obj)
}

var __privateSet = (obj, privateCollection, value) => {
  if (!privateCollection.has(obj)) {
    throw new TypeError('Attempted to set private field on non-instance')
  }
  privateCollection.set(obj, value)
  return value
}

var __privateMethod = (obj, privateCollection, fn) => {
  if (!privateCollection.has(obj)) {
    throw new TypeError('Attempted to get private method on non-instance')
  }
  return fn
}

// js/common/product/product-rerender.js
// Helper to query into an HTML fragment returned from AJAX responses
function deepQuerySelector(htmlFragment, selector) {
  if (!htmlFragment) return null

  // If we receive a string, parse it into a DocumentFragment
  if (typeof htmlFragment === 'string') {
    const template = document.createElement('template')
    template.innerHTML = htmlFragment
    return template.content.querySelector(selector)
  }

  // If we receive a DOM node/document/fragment, query it directly
  if (htmlFragment.querySelector) {
    return htmlFragment.querySelector(selector)
  }

  return null
}

var _abortController8, _ProductRerender_instances, onRerender_fn
var ProductRerender = class extends HTMLElement {
  constructor() {
    super(...arguments)
    __privateAdd(this, _ProductRerender_instances)
    __privateAdd(this, _abortController8)
  }
  connectedCallback() {
    __privateSet(this, _abortController8, new AbortController())
    if (!this.id) {
      console.warn(
        'The <product-rerender> requires an ID to identify the element to re-render.'
      )
      return
    }

    // Listen for this theme's variant:update events instead of a custom product:rerender
    document.addEventListener(
      'variant:update',
      __privateMethod(this, _ProductRerender_instances, onRerender_fn).bind(
        this
      ),
      { signal: __privateGet(this, _abortController8).signal }
    )
  }
  disconnectedCallback() {
    __privateGet(this, _abortController8).abort()
  }
}
_abortController8 = new WeakMap()
_ProductRerender_instances = new WeakSet()
onRerender_fn = function (event) {
  const data = event?.detail?.data
  if (!data || !data.html) {
    return
  }

  // If bound to a specific product, ignore updates for other products
  if (
    this.dataset.productId &&
    data.productId &&
    data.productId !== this.dataset.productId
  ) {
    return
  }

  const matchingElement = deepQuerySelector(data.html, `#${this.id}`)
  if (!matchingElement) {
    return
  }
  const focusedElement = document.activeElement
  const productChange = Boolean(data.newProduct)
  if (!this.hasAttribute('allow-partial-rerender') || productChange) {
    this.replaceWith(matchingElement)
  } else {
    const blockTypes = [
      'sku',
      'badges',
      'quantity-selector',
      'volume-pricing',
      'price',
      'payment-terms',
      'variant-picker',
      'inventory',
      'buy-buttons',
      'pickup-availability',
      'liquid'
    ]
    blockTypes.forEach((blockType) => {
      this.querySelectorAll(`[data-block-type="${blockType}"]`).forEach(
        (element) => {
          const matchingBlock = matchingElement.querySelector(
            `[data-block-type="${blockType}"][data-block-id="${element.getAttribute('data-block-id')}"]`
          )
          if (matchingBlock) {
            if (blockType === 'buy-buttons') {
              element
                .querySelector('buy-buttons')
                .replaceWith(matchingBlock.querySelector('buy-buttons'))
            } else if (blockType === 'quantity-selector') {
              const quantitySelectorElement =
                element.querySelector('quantity-selector')
              if (quantitySelectorElement) {
                const existingQuantity = quantitySelectorElement.quantity
                element.replaceWith(matchingBlock)
                matchingBlock.querySelector('quantity-selector').quantity =
                  existingQuantity
              }
            } else {
              element.replaceWith(matchingBlock)
            }
          }
        }
      )
    })
  }
  if (focusedElement.id) {
    const element = document.getElementById(focusedElement.id)
    if (this.contains(element)) {
      element.focus()
    }
  }
}
if (!window.customElements.get('product-rerender')) {
  window.customElements.define('product-rerender', ProductRerender)
}

// js/sections/product.js
var _intersectionObserver3,
  _formElement,
  _footerElement,
  _latestFooterCondition,
  _latestFormCondition,
  _ProductStickyBar_instances,
  onFormVisibilityChange_fn
var ProductStickyBar = class extends HTMLElement {
  constructor() {
    super(...arguments)
    __privateAdd(this, _ProductStickyBar_instances)
    __privateAdd(
      this,
      _intersectionObserver3,
      new IntersectionObserver(
        __privateMethod(
          this,
          _ProductStickyBar_instances,
          onFormVisibilityChange_fn
        ).bind(this)
      )
    )
    __privateAdd(this, _formElement)
    __privateAdd(this, _footerElement)
    __privateAdd(this, _latestFooterCondition, false)
    __privateAdd(this, _latestFormCondition, false)
  }
  connectedCallback() {
    __privateSet(this, _formElement, document.forms[this.getAttribute('form')])
    const footerElement =
      document.querySelector('[id^="shopify-section-footer"]') ||
      document.querySelector('.footer') ||
      document.querySelector('footer')

    __privateSet(this, _footerElement, footerElement || null)

    // If we couldn't find a footer element, treat the footer condition as satisfied
    if (!footerElement) {
      __privateSet(this, _latestFooterCondition, true)
    }

    if (__privateGet(this, _formElement)) {
      __privateGet(this, _intersectionObserver3).observe(
        __privateGet(this, _formElement)
      )
      if (footerElement) {
        __privateGet(this, _intersectionObserver3).observe(footerElement)
      }
    }
  }
  disconnectedCallback() {
    __privateGet(this, _intersectionObserver3).disconnect()
  }
}
_intersectionObserver3 = new WeakMap()
_formElement = new WeakMap()
_footerElement = new WeakMap()
_latestFooterCondition = new WeakMap()
_latestFormCondition = new WeakMap()
_ProductStickyBar_instances = new WeakSet()
onFormVisibilityChange_fn = function (entries) {
  const [formEntry, footerEntry] = [
    entries.find((entry) => entry.target === __privateGet(this, _formElement)),
    entries.find((entry) => entry.target === __privateGet(this, _footerElement))
  ]
  if (formEntry) {
    __privateSet(
      this,
      _latestFormCondition,
      !formEntry.isIntersecting && formEntry.boundingClientRect.bottom < 0
    )
  }
  if (footerEntry) {
    __privateSet(this, _latestFooterCondition, !footerEntry.isIntersecting)
  }
  this.classList.toggle(
    'is-visible',
    __privateGet(this, _latestFooterCondition) &&
      __privateGet(this, _latestFormCondition)
  )
}
if (!window.customElements.get('product-sticky-bar')) {
  window.customElements.define('product-sticky-bar', ProductStickyBar)
}
